const Footer = () => {
  return (
    <footer className="text-gray-400 text-xs pt-14 pb-10 text-center">
      ©
      <a className="text-gray-600 no-underline" href="https://github.com/maeng2418">
        Maeng
      </a>{' '}
      All rights reserved.
    </footer>
  )
}

export default Footer
